module.exports = __webpack_public_path__ + "static/e-boutique_fr-7333f544877f9a2e9686b995b46b8274.png";